export enum StoryAudioType {
  FullAudio = 'full-audio',
  Teaser = 'teaser',
  Unlocked = 'unlocked',
}
